<template>
  <div>
    <div>
      <label class="p-label required" v-text="title"/>
    </div>

    <div class="group-input">
      <InputText :value="value"
                 :disabled="disabled"
                 type="text"
                 style="width: 100%"
                 @input="inputConfirmPhone"
      />
      <Button :disabled="generateCodeDisable || disabled"
              :icon="'fas fa-sync'"
              @click="resendCode"
      />
    </div>

    <InlineMessage severity="info" style="width: 100%">
      {{ infoResendSms }}

      <ReverseTimer v-if="generateCodeDisable"
                    :seconds="generateCodeDisableTime"
                    @end="updateGenerateCodeDisable"
      />
    </InlineMessage>

    <InlineMessage v-if="errorMessage"
                   v-text="errorMessage"
                   severity="error"
                   style="width: 100%"
    />
  </div>
</template>

<script>
import ReverseTimer from '@/components/timer/ReverseTimer'

export default {
  name: 'InputConfirmCode',
  components: {
    ReverseTimer
  },
  props: {
    value: String,
    title: String,
    disabled: Boolean,
    generateCodeDisable: Boolean,
    generateCodeDisableTime: Number,
    errorMessage: String,
    infoResendSms: String
  },
  methods: {
    inputConfirmPhone(event) {
      this.$emit('input', event)
    },
    updateGenerateCodeDisable() {
      this.$emit('update:generateCodeDisable', false)
    },
    resendCode() {
      this.$emit('resend-code')
    }
  }
}
</script>
<style>
.group-input {
  display: flex;
}
</style>
